module.exports = __webpack_public_path__ + "23b83d0d90e1d32e6933df4010e5b97b.png";